import { createApi } from '@reduxjs/toolkit/query/react';
import { apiEndpoints } from 'Utils/ApiEndpoints';
import { createAuthBaseQuery } from './baseQuery';

export const profileApi = createApi({
    reducerPath: 'profileApi',
    baseQuery: createAuthBaseQuery(),
    tagTypes: ['User'],
    endpoints: (builder) => ({
        getDataProfile: builder.query({
            query: () => ({
                url: `${apiEndpoints?.getProfileData}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        updatePassword: builder.mutation({
            query: (data) => ({
                url: apiEndpoints?.updatePassword,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['User'],
        }),
        updateAdminData: builder.mutation({
            query: (data) => ({
                url: apiEndpoints?.updateAdmin,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['User'],
        }),
        getDashboard: builder.query({
            query: () => ({
                url: `${apiEndpoints?.getDashboardUrl}`,
                method: 'POST',
            }),
        }),
        getDashboardGraph: builder.query({
            query: ({filter =""}) => ({
                url: `${apiEndpoints?.getDashboardGraphUrl}?filterType=${filter}`,
                method: 'GET',
            }),
        }),
    })
});

export const {
    useUpdatePasswordMutation, useUpdateAdminDataMutation, useGetDataProfileQuery, useGetDashboardQuery, useGetDashboardGraphQuery
} = profileApi;
